import axios from "axios";
import { Token } from "@appTypes/index";

interface TokenApiResponse {
  success: boolean;
  token: Token;
}

// Dedicated raw client — intentionally not one of the managed instances
// so it never triggers the auth interceptors.
const tokenClient = axios.create({
  baseURL: window.tpConfig?.TP_API_BASE_URL,
  withCredentials: true,
});

const getToken = async (): Promise<Token | null> => {
  try {
    const response = await tokenClient.get<TokenApiResponse>("/users/v3/token");
    return response.data.token;
  } catch {
    return null;
  }
};

export default getToken;
